/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetUngatedPaginatedShopCategoryQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  businessLine?: Types.InputMaybe<Types.BusinessLine>;
  includeCategory: Types.Scalars["Boolean"]["input"];
  includeTheme: Types.Scalars["Boolean"]["input"];
  hideOutOfStockItems: Types.Scalars["Boolean"]["input"];
}>;
export type GetUngatedPaginatedShopCategoryQuery = {
  __typename?: "Query";
  shopContent?: {
    __typename?: "ShopContent";
    categoryPage?: {
      __typename?: "ShopCategoryPage";
      id: string;
      category?: {
        __typename?: "ShopCategory";
        id: string;
        shopProducts: {
          __typename?: "ShopProductConnection";
          pageInfo: {
            __typename?: "PageInfo";
            hasNextPage: boolean;
            endCursor?: string | null;
          };
          nodes: Array<{
            __typename: "ShopProduct";
            id: string;
            businessLine: Types.BusinessLine;
            name: string;
            brand: {
              __typename?: "Brand";
              name: string;
            };
            variantBySkuId?: {
              __typename?: "ShopProductVariant";
              id: string;
              color: {
                __typename?: "Color";
                uniqueColorId: string;
              };
            } | null;
            colorOptions: Array<{
              __typename?: "ColorOption";
              name: string;
              uniqueColorId: string;
              swatch: {
                __typename?: "ColorSwatch";
                hex: string;
                url?: string | null;
              };
              inventory: {
                __typename?: "ShopProductColorInventory";
                availability: Types.InventoryAvailability;
              };
              variant: {
                __typename?: "ShopProductVariant";
                id: string;
                sku: string;
                url: string;
                price: {
                  __typename?: "Money";
                  currency: Types.Currency;
                  value: number;
                };
                media: Array<{
                  __typename?: "ShopMedia";
                  altText: string;
                  contentGroup: string;
                  contentName: string;
                  originalSrc: string;
                }>;
                promoDiscountOffer?: {
                  __typename?: "PromoDiscountOffer";
                  displayLabel: {
                    __typename?: "RichText";
                    formatted: string;
                  };
                } | null;
              };
            }>;
          }>;
        };
      } | null;
    } | null;
  } | null;
  fixTheme?: {
    __typename?: "FixTheme";
    title: string;
    id: string;
    shopProducts: {
      __typename?: "ShopProductConnection";
      pageInfo: {
        __typename?: "PageInfo";
        hasNextPage: boolean;
        endCursor?: string | null;
      };
      nodes: Array<{
        __typename: "ShopProduct";
        id: string;
        businessLine: Types.BusinessLine;
        name: string;
        brand: {
          __typename?: "Brand";
          name: string;
        };
        variantBySkuId?: {
          __typename?: "ShopProductVariant";
          id: string;
          color: {
            __typename?: "Color";
            uniqueColorId: string;
          };
        } | null;
        colorOptions: Array<{
          __typename?: "ColorOption";
          name: string;
          uniqueColorId: string;
          swatch: {
            __typename?: "ColorSwatch";
            hex: string;
            url?: string | null;
          };
          inventory: {
            __typename?: "ShopProductColorInventory";
            availability: Types.InventoryAvailability;
          };
          variant: {
            __typename?: "ShopProductVariant";
            id: string;
            sku: string;
            url: string;
            price: {
              __typename?: "Money";
              currency: Types.Currency;
              value: number;
            };
            media: Array<{
              __typename?: "ShopMedia";
              altText: string;
              contentGroup: string;
              contentName: string;
              originalSrc: string;
            }>;
            promoDiscountOffer?: {
              __typename?: "PromoDiscountOffer";
              displayLabel: {
                __typename?: "RichText";
                formatted: string;
              };
            } | null;
          };
        }>;
      }>;
    };
  } | null;
};
export type ShopProductItemFragment = {
  __typename?: "ShopProduct";
  id: string;
  businessLine: Types.BusinessLine;
  name: string;
  brand: {
    __typename?: "Brand";
    name: string;
  };
  variantBySkuId?: {
    __typename?: "ShopProductVariant";
    id: string;
    color: {
      __typename?: "Color";
      uniqueColorId: string;
    };
  } | null;
  colorOptions: Array<{
    __typename?: "ColorOption";
    name: string;
    uniqueColorId: string;
    swatch: {
      __typename?: "ColorSwatch";
      hex: string;
      url?: string | null;
    };
    inventory: {
      __typename?: "ShopProductColorInventory";
      availability: Types.InventoryAvailability;
    };
    variant: {
      __typename?: "ShopProductVariant";
      id: string;
      sku: string;
      url: string;
      price: {
        __typename?: "Money";
        currency: Types.Currency;
        value: number;
      };
      media: Array<{
        __typename?: "ShopMedia";
        altText: string;
        contentGroup: string;
        contentName: string;
        originalSrc: string;
      }>;
      promoDiscountOffer?: {
        __typename?: "PromoDiscountOffer";
        displayLabel: {
          __typename?: "RichText";
          formatted: string;
        };
      } | null;
    };
  }>;
};
export const ShopProductItemFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "ShopProductItem"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProduct"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "brand"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "businessLine"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "variantBySkuId"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "color"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "uniqueColorId"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "colorOptions"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "ObjectValue",
            fields: [{
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "availableInventory"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "hideOutOfStockItems"
                }
              }
            }]
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "uniqueColorId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "swatch"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hex"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "url"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "inventory"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "availability"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "variant"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "sku"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "price"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "currency"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "value"
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "media"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "altText"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "contentGroup"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "contentName"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "originalSrc"
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "promoDiscountOffer"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "input"
                  },
                  value: {
                    kind: "ObjectValue",
                    fields: [{
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "channel"
                      },
                      value: {
                        kind: "EnumValue",
                        value: "SHOP"
                      }
                    }]
                  }
                }],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "displayLabel"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "formatted"
                        }
                      }]
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "url"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const GetUngatedPaginatedShopCategoryDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getUngatedPaginatedShopCategory"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "id"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ID"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "first"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "Int"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "after"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "businessLine"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "BusinessLine"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "includeCategory"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Boolean"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "includeTheme"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Boolean"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "hideOutOfStockItems"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Boolean"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopContent"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "businessLine"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "businessLine"
            }
          }
        }],
        directives: [{
          kind: "Directive",
          name: {
            kind: "Name",
            value: "include"
          },
          arguments: [{
            kind: "Argument",
            name: {
              kind: "Name",
              value: "if"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "includeCategory"
              }
            }
          }]
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "categoryPage"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "categoryId"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "category"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "shopProducts"
                    },
                    arguments: [{
                      kind: "Argument",
                      name: {
                        kind: "Name",
                        value: "first"
                      },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "first"
                        }
                      }
                    }, {
                      kind: "Argument",
                      name: {
                        kind: "Name",
                        value: "after"
                      },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "after"
                        }
                      }
                    }],
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "pageInfo"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "hasNextPage"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "endCursor"
                            }
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "nodes"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "__typename"
                            }
                          }, {
                            kind: "FragmentSpread",
                            name: {
                              kind: "Name",
                              value: "ShopProductItem"
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "fixTheme"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "id"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "id"
            }
          }
        }],
        directives: [{
          kind: "Directive",
          name: {
            kind: "Name",
            value: "include"
          },
          arguments: [{
            kind: "Argument",
            name: {
              kind: "Name",
              value: "if"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "includeTheme"
              }
            }
          }]
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "title"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "shopProducts"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "first"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "first"
                }
              }
            }, {
              kind: "Argument",
              name: {
                kind: "Name",
                value: "after"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "after"
                }
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "pageInfo"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "hasNextPage"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "endCursor"
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "nodes"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "__typename"
                    }
                  }, {
                    kind: "FragmentSpread",
                    name: {
                      kind: "Name",
                      value: "ShopProductItem"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }, ...ShopProductItemFragmentDoc.definitions]
} as unknown as DocumentNode;

/**
 * __useGetUngatedPaginatedShopCategoryQuery__
 *
 * To run a query within a React component, call `useGetUngatedPaginatedShopCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUngatedPaginatedShopCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUngatedPaginatedShopCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      businessLine: // value for 'businessLine'
 *      includeCategory: // value for 'includeCategory'
 *      includeTheme: // value for 'includeTheme'
 *      hideOutOfStockItems: // value for 'hideOutOfStockItems'
 *   },
 * });
 */
export function useGetUngatedPaginatedShopCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetUngatedPaginatedShopCategoryQuery, GetUngatedPaginatedShopCategoryQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetUngatedPaginatedShopCategoryQuery, GetUngatedPaginatedShopCategoryQueryVariables>(GetUngatedPaginatedShopCategoryDocument, options);
}
export function useGetUngatedPaginatedShopCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUngatedPaginatedShopCategoryQuery, GetUngatedPaginatedShopCategoryQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetUngatedPaginatedShopCategoryQuery, GetUngatedPaginatedShopCategoryQueryVariables>(GetUngatedPaginatedShopCategoryDocument, options);
}
export type GetUngatedPaginatedShopCategoryQueryHookResult = ReturnType<typeof useGetUngatedPaginatedShopCategoryQuery>;
export type GetUngatedPaginatedShopCategoryLazyQueryHookResult = ReturnType<typeof useGetUngatedPaginatedShopCategoryLazyQuery>;
export type GetUngatedPaginatedShopCategoryQueryResult = Apollo.QueryResult<GetUngatedPaginatedShopCategoryQuery, GetUngatedPaginatedShopCategoryQueryVariables>;